import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col justify-evenly w-full md:p-20 p-5 bg-[#1a1a1a] text-white">
      <div className="flex flex-col justify-evenly md:px-20 px-0 md:mx-20">
     
        {/* NEW CONTENT FOR FUSION SPIN */}
        <div className="text-[#bababa] space-y-5 pt-10">
          <h1 className="text-[#FF5300] text-2xl font-bold">Privacy Policy for Fusion Spin</h1>
          <p><strong>Data Controller:</strong><br />
          Fusion Spin (hereafter referred to as “Fusion Spin”).<br />
          Address: [Insert Address Here]<br />
          Email: [Insert Contact Email Here]</p>

          <p><strong>Main Purpose of Processing:</strong><br />
          Your data will be processed to manage your interactions with the Fusion Spin website and, if applicable, to establish, maintain, and manage commercial, contractual, or pre-contractual relationships with you.</p>

          <p><strong>Legal Basis:</strong><br />
          The data will be processed based on:<br />
          - The performance of a contract<br />
          - Your consent<br />
          - Legitimate interests of Fusion Spin<br />
          - Application of pre-contractual measures</p>

          <p><strong>Potential Recipients of the Data:</strong><br />
          - Public authorities<br />
          - Companies in the Fusion Spin business group (slot/casino sector)</p>

          <p><strong>Data Protection Rights:</strong><br />
          You may revoke consent and have rights to:<br />
          - Access, rectify, erase data<br />
          - Object to or limit processing<br />
          - Data portability<br />
          Contact:<br />
          Fusion Spin<br />
          [Insert Full Address Here]<br />
          Email: [Insert Contact Email Here]</p>

          <h2 className="text-[#FF5300] text-2xl font-bold">1. Information About Fusion Spin</h2>
          <p>This Privacy Policy governs data processing by Fusion Spin regarding users accessing or contacting us via https://www.fusionspin.com.</p>
          <p>Fusion Spin provides slot game development and casino outsourcing services.</p>

          <h3 className="text-xl font-semibold text-[#FF5300]">1.1 Scope of this Privacy Policy</h3>
          <p>This applies to clients, users, suppliers, employees, and job candidates interacting with Fusion Spin via the Website.</p>

          <h2 className="text-[#FF5300] text-2xl font-bold">2. Personal Data Processed, Purposes, and Legal Basis</h2>
          <p>Fusion Spin processes only necessary data for service provision, inquiries, or commercial/contractual engagement.</p>

          <p><strong>2.1 Based on Contractual Performance:</strong><br />
          - Respond to inquiries<br />
          - Manage Website relationships</p>

          <p><strong>2.2 Based on Legitimate Interest:</strong><br />
          - Website analytics<br />
          - Internal data sharing for efficiency</p>

          <h2 className="text-[#FF5300] text-2xl font-bold">3. Data Processing During Website Navigation</h2>
          <p>Browsing the Website may result in data processing. Refer to our Cookies Policy for more.</p>

          <h2 className="text-[#FF5300] text-2xl font-bold">4. Data Security Measures</h2>
          <p>Fusion Spin applies strong technical and organizational measures for data protection, but note that internet transmission has inherent risks.</p>

          <h2 className="text-[#FF5300] text-2xl font-bold">5. Data Retention Period</h2>
          <p>Data is retained as required by purpose or legal need. Once unneeded, it will be securely deleted unless legally required otherwise.</p>

          <h2 className="text-[#FF5300] text-2xl font-bold">6. Your Rights Over Your Personal Data</h2>
          <p>You may access, correct, delete, limit, or object to processing. Contact:<br />
          Email: [Insert Contact Email Here]</p>
          <p>If rights are violated, contact your local data authority.</p>

          <h2 className="text-[#FF5300] text-2xl font-bold">7. Contact Fusion Spin</h2>
          <p>Email: [Insert Contact Email Here]</p>
          <p>© 2025 Fusion Spin. All rights reserved.</p>
        </div>
        <p className="text-[#bababa] pb-5">
          If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.
        </p>
        <h2 className="text-[#FF5300] text-2xl font-bold py-5">Consent</h2>
        <p className="text-[#bababa] pb-5">By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>
        <h2 className="text-[#FF5300] text-2xl font-bold py-5">Information we collect</h2>
        <p className="text-[#bababa] pb-5">
          The personal information that you are asked to provide, and the reasons why you are asked to provide it,
          will be made clear to you at the point we ask you to provide your personal information.
        </p>
        <h2 className="text-[#FF5300] text-2xl font-bold py-5">How we use your information</h2>
        <ul role="list" className="list-none pl-5 space-y-3 text-[#dadada]">
          <li>Provide, operate, and maintain our website</li>
          <li>Improve, personalize, and expand our website</li>
          <li>Understand and analyze how you use our website</li>
          <li>Develop new products, services, features, and functionality</li>
          <li>Communicate with you, either directly or through one of our partners</li>
          <li>Send you emails</li>
          <li>Find and prevent fraud</li>
        </ul>
        <h2 className="text-[#FF5300] text-2xl font-bold py-5">Log Files</h2>
        <p className="text-[#bababa] pb-5">
          Casino Master Live follows a standard procedure of using log files. These files log visitors when they visit websites.
          The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website,
          and gathering demographic information.
        </p>
        <h2 className="text-[#FF5300] text-2xl font-bold py-5">Third Party Privacy Policies</h2>
        <p className="text-[#bababa] pb-5">
          Casino Master Live's Privacy Policy does not apply to other advertisers or websites.
          We advise you to consult the respective Privacy Policies of these third-party ad servers for more detailed information.
        </p>
        <h2 className="text-[#FF5300] text-2xl font-bold py-5">Children's Information</h2>
        <p className="text-[#bababa] pb-5">
          Another part of our priority is adding protection for children while using the internet.
          Casino Master Live does not knowingly collect any Personal Identifiable Information from children under the age of 13.
          If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately.
        </p>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
